// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_kf-1";
export var rowFirst = "_kf-3";
export var rowLast = "_kf-5";
export var rowMiddle = "_kf-4";
export var ticketListScroll = "_kf-2";
export var ticketStack = "_kf-0";